/* eslint-disable eqeqeq */
import {
  useState,
  useEffect,
  useCallback,
  useLayoutEffect,
  useRef,
} from "react";
import { StockTransfer } from "../../Redux/roStore";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import { RoundingDigitRo } from "../../Redux/roStore";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import Modal from "@mui/material/Modal";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import Box from "@mui/material/Box";
import GCStockTransfer from "../../Component/Common/ReuseableComponent/GCStockTransfer";

import {
  fAlertToast,
  GetCheck_Monthend_DueDate,
  GetGitterColumns,
} from "../../Utility/Utilitys";
import { fExecuteAPI } from "../../Server/Apis";
import { inv05_SalesOrder_SOPDetailStockValidation_GETROW } from "../../Server/ApiV2";
import { fFocusInput } from "../../Utility/Utilitys";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import WmsFooter from "./processComponent/WmsFooter";
import GCReverse from "../../Component/Common/ReuseableComponent/GCReverse";
import {
  Set_WmsStockTransfer_HeadObject_Set,
  Set_WmsStockTransfer_HeadObject_Init,
  Wms_StockTransfer_HeadObject_TypeDependency_Set,
  Wms_StockTransfer_HeadObject_Type_Set,
} from "./SliceWmsStockTransfer";
import "./StockTransfer.css";
import { Wms_StockTransfer_HeadObject_New_Set } from "./SliceWmsStockTransfer";
import { Set_StockTransfer_HeadObject_A_DocStat } from "./SliceWmsStockTransfer";
import {
  CmpButton,
  CmpButtonKIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import {
  fRightClick,
  fLeftClick,
  sTax,
  sTransferType,
  sTrnTyp,
  sStatusArr,
  fKeyStockTransfer,
  fKeyStockTransferContent,
  GetUnitArr,
  GetItemFullSearchArr,
  ItemSearchData,
  GetSearchItem,
  fItemCodeDependency,
  ErrorMsg,
  ErrorMsgDetail,
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fSaveHead,
  fDisplay,
  fStockTransferCal,
  //reverse
  fCloseReverseTransactionModal,
  fOpenReverseTransactionModal,
  fReverse,

  //Head
  GetHeadLocation,
  fLocationDependency,

  //validation
  GetItemAttributesPurchase,
  fGetValidationDetailInfo_Server,
  // Approve
  GetValidateHead_Server,
  GetValidateCostVariance,
  GetAttributes,
  getTransItemStockUOM,
  GetHeadGrid,
  Unit_Onchange_001,
} from "./StockTransferAction";
// import { set } from 'date-fns/esm';
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { fCheck_Doc_Rights_001 } from "./../../Utility/Utilitys";
import {
  FShortCutKey,
  GetAccountPostingDetail,
  GetLinkDocument,
} from "./../../Utility/Utilitys";
import GCAccountDetail from "./../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "./../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "./../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GCHead from "./processComponent/GCHead";
import GCContent from "./processComponent/GCContent";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";

export default function WmsStockTransfer() {
  const dispatch = useDispatch();
  const { roundingDigit } = RoundingDigitRo();
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value

  const vMediaQuery = useMediaQuery("(max-width:750px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxWmsHead = useSelector(
    (state) => state.SliceWmsStockTransfer.value.HeadObject
  );

  const vRdxGRNtax1 = useSelector((state) => state.SliceGRN.value.tax.tax1);
  const vRdxGRNtax2 = useSelector((state) => state.SliceGRN.value.tax.tax2);
  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value

  const [sRoundingVal, setRoundingVal] = useState(roundingDigit);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });
  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [sLoading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [sArr, setArr] = useState([]);

  //HEAD
  const [sDocLoading, setDocLoading] = useState([]);
  const [sFromLocation, setFromLocation] = useState([]);
  const [sToLocation, setToLocation] = useState([]);
  const sType = ["", "DC TO OUTLET", "OUTLET TO DC"];

  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);
  const [sFooterObj, setFooterObj] = useState({
    F_CrNetAmt: (0).toFixed(sRoundingVal),
    F_CrTaxAmt: (0).toFixed(sRoundingVal),
    F_RebateNetAmt: (0).toFixed(sRoundingVal),
    F_RebateTaxAmt: (0).toFixed(sRoundingVal),
    F_GrossAmt: (0).toFixed(sRoundingVal),
    F_TaxAmt: (0).toFixed(sRoundingVal),
    F_NetAmt: (0).toFixed(sRoundingVal),
  });
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });

  //head grid
  const [sHeadGridRow, setHeadGridRow] = useState([]);
  const [sHeadGridColumn, setHeadGridColumn] = useState([
    { field: "Location", headerName: "Location", width: 110 },
    { field: "StkQty", headerName: "Stk", width: 50 },
    { field: "PRQty", headerName: "PR", width: 50 },
    { field: "SOQty", headerName: "SO", width: 50 },
    { field: "DOQty", headerName: "DO", width: 50 },
    { field: "SIQty", headerName: "INV", width: 50 },
    { field: "TRFQty", headerName: "TRF", width: 50 },
    { field: "ADJQty", headerName: "ADJ", width: 50 },
    { field: "Reserved", headerName: "Rsvd", width: 50 },
    { field: "AvlQty", headerName: "Avl", width: 50 },
    { field: "id", headerName: "id", hide: true },
  ]);
  const [headGridShow, setHeadGridShow] = useState(false);

  //DETAIL
  const [sUnit, setUnit] = useState([]);
  const [sDetailGridData, setDetailGridData] = useState([]); //DetailGridData Select
  const [isSaveLoaded, setSaveLoaded] = useState(false);

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_BaseQty: (0).toFixed(sRoundingVal), //Decimal
    Reason: "",
  };
  const [sReason, setReason] = useState([]);
  const [sBufferObj, setBufferObj] = useState({
    B_Srno: 0, // int
    B_Itmcd: "",
    B_ItmName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_BaseQty: (0).toFixed(sRoundingVal), //Decimal
    Reason: "",
  });

  //Modal

  //Reverse
  const [sReverseTransactionModal, setReverseTransactionModal] =
    useState(false);
  const [sRevNarr, setRevNarr] = useState(""); //for Reverse API

  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      trnTyp: sTrnTyp,
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead.A_VocNo,
      A_PostDt: moment(vRdxWmsHead.A_PostDt).format("MM/DD/YYYY"),
      A_Loc: vRdxWmsHead.A_FromLoc,
      A_Party: vRdxWmsHead.A_Party,
      userCd: vRdxuserInfo.UserID,
      IP: vRdxuserInfo.IP,
      netAmt: Number(sFooterObj.F_NetAmt),
      revNarr: sRevNarr,
      A_Type: vRdxWmsHead.A_Type,
    };
    const vRevereTransaction = await fExecuteAPI(
      "WMINV10_reverseTransaction_GETROW",
      vRevereTransactionObj
    );
    return vRevereTransaction;
  };

  //HEAD FUNCTION
  const fGrnType = async (event) => {
    var vGrnType = sDocLoading?.find((obj, index) => {
      return obj.VocTyp === event.target.value;
    });

    dispatch(
      Set_WmsStockTransfer_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp: vGrnType?.VocTyp,
        A_VocTypName: vGrnType?.VocName,
      })
    );
  };

  const fGrnDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_WmsStockTransfer_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: "",
        })
      );
    } else {
      dispatch(
        Set_WmsStockTransfer_HeadObject_Set({
          ...vRdxWmsHead,
          A_PostDt: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_WmsStockTransfer_HeadObject_Set({
    //     ...vRdxWmsHead,
    //     A_PostDt: event.$d,
    //   })
    // );
  };

  const fInvDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_WmsStockTransfer_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: "",
        })
      );
    } else {
      dispatch(
        Set_WmsStockTransfer_HeadObject_Set({
          ...vRdxWmsHead,
          A_RefDt: event?.$d,
        })
      );
    }

    // dispatch(
    //   Set_WmsStockTransfer_HeadObject_Set({ ...vRdxWmsHead, A_RefDt: event.$d })
    // );
  };

  const fType = async (event) => {
    let iDefaultTaxType = vRdxWmsHead.TaxType;
    let iTaxPerc = sBufferObj.B_TaxPerc;
    dispatch(
      Wms_StockTransfer_HeadObject_Type_Set({
        A_Type: event.target.value,
      })
    );
    let { LocFrom, LocTo } = await GetHeadLocation(
      dispatch,
      setFromLocation,
      setToLocation
    );

    setFromLocation(LocFrom);
    setToLocation(LocTo);
    iDefaultTaxType =
      LocFrom.length > 0 && LocTo.length > 0
        ? LocFrom[0].TaxRegNo == LocTo[0].TaxRegNo
          ? sTax[0].Uid
          : sTax[1].Uid
        : sTax[2].Uid;
    dispatch(
      Wms_StockTransfer_HeadObject_TypeDependency_Set({
        A_FromLoc: LocFrom[0].UId,
        A_ToLoc: LocTo[0].UId,
        A_FromTrn: LocFrom[0].TaxRegNo,
        A_ToTrn: LocTo[0].TaxRegNo,
        TaxType: iDefaultTaxType,
      })
    );
    let Locparty = LocTo.length > 0 ? LocTo[0].UId : "";

    fLocationDependency(Locparty, dispatch);
  };

  const fTax = async (event) => {
    var vTax = sTax.find((option, index) => {
      return option.Uid === event.target.value;
    });
    dispatch(
      Set_WmsStockTransfer_HeadObject_Set({
        ...vRdxWmsHead,
        TaxType: vTax.Uid,
        TaxTypeName: vTax.Name,
      })
    );
  };
  const fTransferType = async (event) => {
    dispatch(
      Set_WmsStockTransfer_HeadObject_Set({
        ...vRdxWmsHead,
        TransferType: event.target.value,
      })
    );
  };

  const fFromLocation = async (e) => {
    let vFromLoaction = sFromLocation.find((obj) => {
      return obj.UId === e.target.value;
    });
    if (!!vFromLoaction) {
      let iDefaultTaxType =
        vFromLoaction.TaxRegNo == vRdxWmsHead.A_ToTrn
          ? sTax[0].Uid
          : sTax[1].Uid;
      dispatch(
        Set_WmsStockTransfer_HeadObject_Set({
          ...vRdxWmsHead,
          A_FromLoc: vFromLoaction.UId,
          A_FromTrn: vFromLoaction.TaxRegNo,
          TaxType: iDefaultTaxType,
        })
      );
    }
  };

  const fToLocation = async (e) => {
    let vToLoaction = sToLocation.find((obj) => {
      return obj.UId === e.target.value;
    });

    if (!!vToLoaction) {
      let iDefaultTaxType =
        vToLoaction.TaxRegNo == vRdxWmsHead.A_FromTrn
          ? sTax[0].Uid
          : sTax[1].Uid;
      dispatch(
        Set_WmsStockTransfer_HeadObject_Set({
          ...vRdxWmsHead,
          A_ToLoc: vToLoaction.UId,
          A_ToTrn: vToLoaction.TaxRegNo,
          TaxType: iDefaultTaxType,
        })
      );

      fLocationDependency(vToLoaction.UId, dispatch);
    }
  };

  const fCreditLimit = async (e) => {
    dispatch(
      Set_WmsStockTransfer_HeadObject_Set({
        ...vRdxWmsHead,
        CreditLimit: e.target.value,
      })
    );
  };
  const fOsAmount = async (e) => {
    dispatch(
      Set_WmsStockTransfer_HeadObject_Set({
        ...vRdxWmsHead,
        OsAmount: e.target.value,
      })
    );
  };
  const fAvlAmt = async (e) => {
    dispatch(
      Set_WmsStockTransfer_HeadObject_Set({
        ...vRdxWmsHead,
        AvlAmt: e.target.value,
      })
    );
  };

  //FOOTER FUNCTION

  const fHeadNarration = (e) => {
    dispatch(
      Set_WmsStockTransfer_HeadObject_Set({
        ...vRdxWmsHead,
        A_Narr: e.target.value,
      })
    );
  };
  //DETAIL FUNCTIOn
  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
    if (e.target.name == "B_Qty") {
      GetHeadGrid(setHeadGridRow, setHeadGridShow, sBufferObj.B_Itmcd);
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(sRoundingVal),
      }));
    }
    if (e.target.name == "B_Qty") {
      setHeadGridShow(false);
    }
  };

  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
   
 
 await Unit_Onchange_001(              
             vUnitvalue, 
            setBufferObj,
            sBufferObj
           );
    
  };

  const fQty_Save_onKeyUp = (e) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (
        e.key === "Enter" &&
        // !isSaved &&
        vRdxWmsHead.A_DocStat == "ENTER" &&
        !isSaveLoaded
      ) {
        setSaveLoaded(true);
        document.getElementsByName("B_UnitCost")[0]?.blur();
        // setIsSaved(true);
        fSave();
      }
    }, 1000);
  };

  const fItemName = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
    let {
      B_BaseQty, //Decimal
    } = fStockTransferCal(e.target.value, sBufferObj.B_PackQty);
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
    }));
  };

  //Item Dropdowm
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxWmsHead.A_FromLoc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxWmsHead.A_FromLoc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  //ItemSearch
  const fItemSearchKey = async (e) => {
    setLoading(true);
 
    if (e.key === "Enter" || e._reactName === "onClick") {
      if (
        vRdxWmsHead.A_Type === "" ||
        vRdxWmsHead.A_Type === null ||
        vRdxWmsHead.A_Type === undefined
      ) {
        setErrorMsg((obj) => ({
          ...obj,
          A_Type: " Type should not be empty",
        }));
      }
      if (
        vRdxWmsHead.A_FromLoc === "" ||
        vRdxWmsHead.A_FromLoc === null ||
        vRdxWmsHead.A_FromLoc === undefined
      ) {
        setErrorMsg((obj) => ({
          ...obj,
          A_FromLoc: "Location should not be Empty",
        }));
      }
      if (
        vRdxWmsHead.A_ToLoc === "" ||
        vRdxWmsHead.A_ToLoc === null ||
        vRdxWmsHead.A_ToLoc === undefined
      ) {
        setErrorMsg((obj) => ({
          ...obj,
          A_ToLoc: "Location should not be Empty",
        }));
      }

      if (
        vRdxWmsHead.TaxType === "" ||
        vRdxWmsHead.TaxType === null ||
        vRdxWmsHead.TaxType === undefined
      ) {
        setErrorMsg((obj) => ({
          ...obj,
          TaxType: "Tax Type should not be Empty",
        }));
      }
      if (
        vRdxWmsHead.A_Type === "" ||
        vRdxWmsHead.A_Type === null ||
        vRdxWmsHead.A_Type === undefined ||
        vRdxWmsHead.A_FromLoc === "" ||
        vRdxWmsHead.A_FromLoc === null ||
        vRdxWmsHead.A_FromLoc === undefined ||
        vRdxWmsHead.A_ToLoc === "" ||
        vRdxWmsHead.A_ToLoc === null ||
        vRdxWmsHead.A_ToLoc === undefined ||
        vRdxWmsHead.TaxType === "" ||
        vRdxWmsHead.TaxType === null ||
        vRdxWmsHead.TaxType === undefined
      ) {
        fAlertToast("FAILED", "Type,FromLoc,ToLoc,TaxType should not be empty");
        return;
      }

      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxWmsHead.A_FromLoc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(
          vItemSearchFull,
          vRdxWmsHead,
          sBufferObj,
          setBufferObj,
          setUnit
        );
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: 0,
        B_BaseQty: 0,
      }));

      setUnit([]);
    }
  };

  //MODAL HEAD

  //Modal ItemSearch
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(
      e.row.ItmCd,
      vRdxWmsHead.A_FromLoc
    );
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(
        vItemSearchFull,
        vRdxWmsHead,
        sBufferObj,
        setBufferObj,
        setUnit
      );
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //MODAL SEARCH

  const [sLocationArr, setLocationArr] = useState([]);
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: "ENTER",
    VocNo: "",
    PostDt: new Date(),
    Loc: sLocationArr[0]?.UId ? sLocationArr[0]?.UId : "",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setSearchModal(true);
    // SALESGROUPSSEARCH_GETROW -search salegroup dropdown
    document.getElementById("IdSearch")?.blur();
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: sLocationArr[0]?.UId,
    }));
    GetSearchValue("", "APICallLocModal", sLocationArr[0]?.UId);
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: new Date(),
      Loc: sLocationArr[0].UId,
      RefNo: "",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearch
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo, dispatch, fNewDetail);
    fCloseSearchModal();
  };

  //GCSearch
  const fTrans_Search_Grid_KeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fTrans_Search_Grid_RowClick(newSelectionModel);
      fDisplay(
        newSelectionModel?.row?.A_VocTyp,
        newSelectionModel?.row?.A_VocNo,
        dispatch,
        fNewDetail
      );
      fCloseSearchModal();
    }
  };

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALLSTATUS", vSelectedValue);
  };

  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
    // setSearchModalObj((obj) => ({
    //   ...obj,
    //   PostDt: moment(event.target.value, "YYYY-MM-DD")._d,
    // }));
    // let changedDate = moment(event.target.value, "YYYY-MM-DD")._d;
    // GetSearchValue("", "APICALLDATE", changedDate);
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UId,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UId);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALLSTATUS" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallLocModal"
    ) {
      let vSearchObj = {
        // VocDt:
        //   xAPICALL === "APICALLDATE"
        //     ? moment(xSTATUS).format("MM/DD/YYYY")
        //     : moment(sSearchModalObj.PostDt).format("MM/DD/YYYY"),

        TrnTyp: sTrnTyp,
        VocNo: sSearchModalObj.VocNo,
        PostDt: "01/01/1900",
        Loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        Status: xAPICALL === "APICALLSTATUS" ? xSTATUS : sSearchModalObj.Status,
        UserCd: vRdxuserInfo.UserID,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vSearchObj);
      const vSearch = await fExecuteAPI("WMINV10_Search_GETROW", FinalObj);
      if (vSearch?.Type?.toUpperCase() === "SUCCESS") {
        let vSearchArr = vSearch?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          A_VocDt: moment(obj.A_VocDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      } else {
        fAlertToast("FAILED", vSearch?.response?.data?.Status);
      }
    }
  };

  //MODAL SEARCH END

  //Modal Audit

  const [xAuditId, setAuditId] = useState("All");
  const [sAuditModal, setAuditModal] = useState(false);
  const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const fOpenAuditModal = () => {
    setAuditModal(true);
  };
  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAuditId(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };
  const fCloseAuditModal = (e) => {
    setAuditModal(false);
  };
  const fonChangeAuditSelect = (e) => {
    setAuditId(e.target.value);
    GetTransAudit(e.target.value);
  };

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = StockTransfer();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end
  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = StockTransfer();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //document
  const [sDocumentModal, setDocumentModal] = useState(false);
  const fDocument = () => {
    fOpenDocumentModal();
  };
  const fOpenDocumentModal = () => {
    setDocumentModal(true);
  };
  const fCloseDocumentModal = (e) => {
    setDocumentModal(false);
  };

  //GCLandedCost

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField?.Type?.toUpperCase() === "SUCCESS") {
      setAuditSelectArr(vAuditField.ResultSet);
      return vAuditField.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField.Message);
      return vAuditField.ResultSet;
    }
  };
  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vTransAuditObj);
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", FinalObj);
    if (vTransAudit?.Type?.toUpperCase() === "SUCCESS") {
      let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };

  //API DETAIL

  //MAIN BUTTON

  const fMove_First = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[0].A_VocTyp,
      sUser_Doc_Arr[0].A_VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(1);
  };

  const fMove_Last = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1]?.A_VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1]?.A_VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };

  const fMove_Previouse = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(
        sUser_Doc_Arr[row - 1]?.A_VocTyp,
        sUser_Doc_Arr[row - 1]?.A_VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };

  const fMove_Next = (e) => {
    fClearErrorMsg();
    setBufferObj(vBufferObjInit);

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(
        sUser_Doc_Arr[row - 1]?.A_VocTyp,
        sUser_Doc_Arr[row - 1]?.A_VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      let webReport = vRdxDBKernObj?.WEB_REPORT_BASE_URL;

      let urlPrint =
        webReport?.Val +
        "/WMS/StockTransfer?trntyp=" +
        sTrnTyp +
        "&voctyp=" +
        vRdxWmsHead.A_VocTyp +
        "&vocno=" +
        vRdxWmsHead.A_VocNo +
        "&prnTyp=" +
        xPrnTyp;
      console.log(urlPrint);
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp, vRdxDBKernObj]
  );
  const fSave3 = async () => {
    let iValidateHeadApprove = await GetValidateHead_Server(
      dispatch,
      false //xapprove false in save
    );

    if (!iValidateHeadApprove) return;

    let vfGetValidationDetailInfo = await fGetValidationDetailInfo_Server(
      sBufferObj,
      ErrorMsgDetail,
      setErrorMsgDetail
    );

    if (!vfGetValidationDetailInfo) return;

    fSave4();
  };
  const fSOPValidation = async () => {
    let vValidationHeadInfoObj = {
      Loc: vRdxWmsHead.A_Loc,
      UserGrp: vRdxuserInfo.UserID,
      TrnTyp: sTrnTyp,
      v_ItmCd: sBufferObj.B_Itmcd,
      v_Unit: sBufferObj.B_Unit,
      v_Qty: sBufferObj.B_Qty,
      v_VocTyp: vRdxWmsHead.A_VocTyp,
      v_VocNo: vRdxWmsHead.A_VocNo,
      v_SrNo: sBufferObj.B_Srno,
    };

    let iValidation = await inv05_SalesOrder_SOPDetailStockValidation_GETROW(
      vValidationHeadInfoObj
    );
    if (iValidation?.status === 200) {
      return iValidation?.data?.ResultSet;
    }
  };

  const fSave4 = async () => {
    // let iResp = await fSOPValidation();
    // if (iResp?.length > 0 && !!iResp[0]?.messgae) {
    //   fAlertToast("FAILED", iResp[0]?.messgae || "Insufficient Stock");
    //   return;
    // } else if (
    //   iResp?.length > 0 &&
    //   (iResp[0]?.messgae === "" ||
    //     iResp[0]?.messgae === null ||
    //     iResp[0]?.messgae === undefined)
    // ) {
    //   fSave5();
    // }
    fSave5();
  };

  const fSave5 = async () => {
    fSaveHead(
      true,
      setUser_Doc_Arr,
      sUser_Doc_Arr,
      dispatch,
      fNewDetail,
      sBufferObj,
      ""
    );
  };

  const fSave2 = async () => {
    let iItemAttri = await GetItemAttributesPurchase(dispatch, sBufferObj);

    if (iItemAttri.length > 0) {
      if (iItemAttri[0].Linking != "") {
        fAlertToast("FAILED", iItemAttri[0].Linking);
        document.getElementsByName("B_ItmName")[0]?.focus();
        return;
      }
      if (iItemAttri[0].LinkingTo != "") {
        fAlertToast("FAILED", iItemAttri[0].LinkingTo);
        document.getElementsByName("B_ItmName")[0]?.focus();
        return;
      }

      if (iItemAttri[0]?.ItmActive != "Y") {
        fAlertToast("FAILED", "Select items is in-activated");
        document.getElementsByName("B_ItmName")[0]?.focus();
        return;
      }
      if (iItemAttri[0]?.ItmActiveTo != "Y") {
        fAlertToast("FAILED", "Select items is in-activated");
        document.getElementsByName("B_ItmName")[0]?.focus();
        return;
      }
      if (iItemAttri[0]?.CentralInhouse === "Y") {
        fAlertToast("FAILED", "Select items is not centra-in-house");
        document.getElementsByName("B_ItmName")[0]?.focus();
        return;
      }
      if (iItemAttri[0]?.Listed == "N") {
        fAlertToast("FAILED", "Select items is not listed");
        document.getElementsByName("B_ItmName")[0]?.focus();
        return;
      }

      // if (iItemAttri[0].TaxDept1 != sBufferObj.B_TaxDept) {
      //   fAlertToast("FAILED", "Select valid Tax Group");
      //   document.getElementsByName("B_TaxDept")[0]?.focus();
      //   return;
      // }

      // if (iItemAttri[0].TaxPerc1 != sBufferObj.B_TaxPerc) {
      //   fAlertToast("FAILED", "Select valid Tax percentage");
      //   document.getElementsByName("B_TaxPerc")[0]?.focus();
      //   return;
      // }

      // if (iItemAttri[0].Tax1Active != "Y") {
      //   fAlertToast("FAILED", "Selected Tax Group is in-activaed");
      //   document.getElementsByName("B_TaxDept")[0]?.focus();
      //   return;
      // }

      fSave3();
    }
  };

  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fCloseReverseTransactionModal(setReverseTransactionModal);
    fClearErrorMsg();

    timeout = setTimeout(async () => {
      setSaveLoaded(false);

      if (vRdxWmsHead.A_DocStat == "POST" || vRdxWmsHead.A_DocStat == "DRAFT") {
        if (sRevNarr == "") {
          fOpenReverseTransactionModal(setReverseTransactionModal);
        } else {
          let reverseResp = await GetRevereTransaction();
          if (reverseResp?.Type?.toUpperCase() == "SUCCESS") {
            fClearErrorMsg();
            setRevNarr("");
            dispatch(
              Set_StockTransfer_HeadObject_A_DocStat({
                A_DocStat: "ENTER",
              })
            );
            fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
          } else if (
            reverseResp.response.status == 400 ||
            reverseResp.response.status == 500
          ) {
            fAlertToast("FAILED", reverseResp.response.data.Status);
          }
        }
      } else if (vRdxWmsHead.A_DocStat != "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxWmsHead.A_DocStat.toLowerCase() + " mode"
        );
        return;
      } else {
        let validation = fValidationHead_Client(
          vRdxWmsHead,
          setErrorMsg,
          sFooterObj
        );

        if (!validation) return;

        let validationDetil = fValidationDetail_Client(
          vRdxWmsHead,
          sBufferObj,
          setErrorMsgDetail,
          sDetailGridData
        );

        if (!validationDetil) return;

        fSave2();
      }
    }, 800);
  };

  const fApprove4 = async (xDocStatus) => {
    let iValidateHeadApprove = await GetValidateHead_Server(
      dispatch,
      true //xapprove true in approve
    );

    if (!iValidateHeadApprove) return;

    fSaveHead(
      false,
      setUser_Doc_Arr,
      sUser_Doc_Arr,
      dispatch,
      fNewDetail,
      sBufferObj,
      xDocStatus
    );
  };

  const fApprove3 = async (xRSCostVariance, xDocStatus) => {
    let iValidateMaxCostVariance = xRSCostVariance.filter((obj) => {
      return obj.GP <= 0;
    });

    if (iValidateMaxCostVariance.length > 0) {
      if (xRSCostVariance[0].AllowNegativeGP == "Y") {
        setTimeout(() => {
          confirmAlert({
            title: "Approve",
            message: "Negative GP \n Are you sure want approve?",
            buttons: [
              {
                className: "alertBtn",
                label: "Yes",
                onClick: () => {
                  fApprove4(xDocStatus);
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => {
                  fAlertToast("FAILED", "Negative GP detected, Approve denied");
                },
              },
            ],
          });
        }, 100);
      } else {
        fAlertToast("FAILED", "Negative GP detected, Approve denied");
      }
    } else {
      fApprove4(xDocStatus);
    }
  };

  const fApprove2 = async (xDocStatus) => {
    let iRSCostVariance = await GetValidateCostVariance(dispatch);
    if (iRSCostVariance.length > 0) {
      let iValidateMaxCostVariance = iRSCostVariance.filter((obj) => {
        return (
          obj.CostVariance > obj.MAX_COST_VARI_PERC ||
          obj.CostVariance < -1 * obj.MAX_COST_VARI_PERC
        );
      });

      if (iValidateMaxCostVariance.length > 0) {
        if (iValidateMaxCostVariance[0].AllowCostVariance === "Y") {
          confirmAlert({
            title: "Approve",
            message:
              "Maximun allowed cost variance is " +
              Number(iValidateMaxCostVariance[0].MAX_COST_VARI_PERC).toFixed(
                2
              ) +
              "\n Are you sure?",
            buttons: [
              {
                className: "alertBtn",
                label: "Yes",
                onClick: () => {
                  fApprove3(iRSCostVariance, xDocStatus);
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => {},
              },
            ],
          });
        } else {
          fAlertToast(
            "FAILED",
            "Maximun allowed cost variance is " +
              Number(iValidateMaxCostVariance[0].MAX_COST_VARI_PERC).toFixed(
                2
              ) +
              ", Approve denied"
          );
        }
      } else {
        fApprove3(iRSCostVariance, xDocStatus);
      }
    } else {
      //iRSCostVariance.length = 0 (no record set found)
      fApprove4(xDocStatus);
    }
  };

  const fApprove = async (xDocStatus) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd != "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetailGridData.length == 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }

      if (Number(vRdxWmsHead.AvlAmt) - Number(sFooterObj.F_NetAmt) <= 0) {
        fAlertToast("FAILED", "Credit limit exceed the available amount");
        return;
      }

      let validation = fValidationHead_Client(
        vRdxWmsHead,
        setErrorMsg,
        sFooterObj
      );

      if (!validation) return;

      if (
        !!vRdxDBKernObj.MONTH_END_VALDN_INV10 &&
        vRdxDBKernObj.MONTH_END_VALDN_INV10?.Val === "Y"
      ) {
        let CheckDueDate = await GetCheck_Monthend_DueDate(
          vRdxWmsHead.A_FromLoc,
          vRdxWmsHead.A_PostDt
        );
        if (!CheckDueDate) return;
        let CheckDueDateToLoc = await GetCheck_Monthend_DueDate(
          vRdxWmsHead.A_ToLoc,
          vRdxWmsHead.A_PostDt
        );
        if (!CheckDueDateToLoc) return;
      }

      fApprove2(xDocStatus);
    }, 800);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
    setErrorMsgDetail(ErrorMsgDetail);
    setRevNarr("");
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName == "") {
      fNewHead();
      fNewDetail(0, sDocLoading[0]?.VocTyp);
      document.getElementsByName("A_PostDt")[0]?.focus();
    } else {
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fNewHead = async () => {
    dispatch(Set_WmsStockTransfer_HeadObject_Init()); // Head Clearing

    let { LocFrom, LocTo } = await GetHeadLocation(
      dispatch,
      setFromLocation,
      setToLocation
    );
    let iDefaultTaxType = "";
    // LocFrom.length > 0 && LocTo.length > 0
    //   ? LocFrom[0].TaxRegNo == LocTo[0].TaxRegNo
    //     ? sTax[0].Uid
    //     : sTax[1].Uid
    //   : sTax[2].Uid;

    // Setting Initial List Box 0th Object
    dispatch(
      Wms_StockTransfer_HeadObject_New_Set({
        A_VocTyp: sDocLoading[0]?.VocTyp,
        A_VocTypName: sDocLoading[0]?.VocName,
        A_VocNo: 0,
        A_FromLoc: "",
        A_ToLoc: "",
        A_FromTrn: "",
        A_ToTrn: "",
        TaxType: iDefaultTaxType,
        TransferType: sTransferType[0].Uid,
        A_Type: sType[0], //sForm
      })
    );

    let Locparty = "";
    fLocationDependency(Locparty, dispatch);
    setNavDocValue(1); // nav init 1
    setDetailGridData([]);
    setBufferObj(vBufferObjInit);
    setFooterObj((obj) => ({
      ...obj,
      F_CrNetAmt: (0).toFixed(sRoundingVal),
      F_CrTaxAmt: (0).toFixed(sRoundingVal),
      F_RebateNetAmt: (0).toFixed(sRoundingVal),
      F_RebateTaxAmt: (0).toFixed(sRoundingVal),
      F_GrossAmt: (0).toFixed(sRoundingVal),
      F_TaxAmt: (0).toFixed(sRoundingVal),
      F_NetAmt: (0).toFixed(sRoundingVal),
    }));

    // document.getElementsByName("A_RefDocNo")[0]?.focus();
  };

  const fNewDetail = (xVocNo, xVocTyp) => {
    let iReason = xVocNo == 0 ? "" : sBufferObj.Reason;
    setBufferObj(vBufferObjInit);
    setBufferObj((obj) => ({
      ...obj,
      Reason: iReason,
    }));
    setUnit([]);

    fLoad_Grid(
      xVocNo,
      0,
      setDetailGridData,
      setFooterObj,
      xVocTyp,
      sRoundingVal
    );

    document.getElementsByName("B_ItmName")[0]?.focus();
  };

  const fDelete = (Srno = sBufferObj.B_Srno) => {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (Srno === 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteHead(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  // DELETESIHEAD_GETROW

  const fDeleteHead = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIHeadObj = {
      A_VocTyp: vRdxWmsHead.A_VocTyp,
      A_VocNo: vRdxWmsHead.A_VocNo,
      IP: vRdxuserInfo.IP,
      UserId: vRdxuserInfo.UserID,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIHeadObj);
    const vDeleteSIHead = await fExecuteAPI(
      "WMINV10_deleteHead_GETROW",
      FinalObj
    );

    if (vDeleteSIHead?.Type?.toUpperCase() === "SUCCESS") {
      if (sBufferObj.B_Srno == 0) {
        // vocno,srno
        dispatch(
          Set_StockTransfer_HeadObject_A_DocStat({
            A_DocStat: "DELETE",
          })
        );
        fDisplay(
          vRdxWmsHead.A_VocTyp,
          vRdxWmsHead.A_VocNo,
          dispatch,
          fNewDetail
        );
        // fNewDetail(
        //   vRdxWmsHead.A_VocNo,
        //   vRdxWmsHead.A_VocTyp,
        // );
        fAlertToast("SUCCESS", "Successfully Deleted");
      }
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async (Srno = sBufferObj.B_Srno) => {
    let vDeleteSIDetailObj = {
      B_VocTyp: vRdxWmsHead.A_VocTyp,
      B_VocNo: vRdxWmsHead.A_VocNo,
      B_Srno: Srno,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await fExecuteAPI(
      "WMINV10_deleteDetails_GETROW",
      FinalObj
    );

    if (vDeleteSIDetail?.Type?.toUpperCase() === "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.B_Srno, // int
      B_Itmcd: item.row.B_Itmcd,
      B_ItmName: item.row.ItemName,
      B_Qty: item.row.B_Qty, //Decimal
      B_Unit: item.row.B_Unit,
      B_UnitName: item.row.UnitName,
      B_BaseQty: item.row.B_BaseQty, //Decimal
      Reason: item.row.B_Reason,
    }));
    let currentUnitArr = await GetUnitArr(item.row.B_Itmcd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
    }));
    fCloseViewModal();
  };

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      setItemToggleDropdown(false);
      setHeadGridShow(false);
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onload = useCallback(async () => {
    let iAttributeResp = await GetAttributes(
      setObjectRights,
      setUser_Doc_Arr,
      setLocationArr,
      setDocLoading,
      setReason
    );

    let icurrentDocLoading = {
      VocTyp: "",
      VocName: "",
      Paymode: "",
    };
    let vDocLoadingArr = iAttributeResp.DocLoading;

    if (vDocLoadingArr?.length > 0) {
      icurrentDocLoading = vDocLoadingArr[0];
    }
    let { LocFrom, LocTo } = await GetHeadLocation(
      dispatch,
      setFromLocation,
      setToLocation
    );
    let vFromLocation = {
      Name1: "",
      UId: "",
      TaxRegNo: "",
    };
    let vToLocation = {
      Name1: "",
      UId: "",
      TaxRegNo: "",
    };

    let Locparty = LocTo.length > 0 ? LocTo[0].UId : "";
    vFromLocation = LocFrom[0];
    vToLocation = LocTo[0];

    // vRdxWmsHead.A_ToLoc
    let iDefaultTaxType = "";
    if (
      vRdxWmsHead.A_ToLoc == "" ||
      vRdxWmsHead?.A_ToLoc == null ||
      vRdxWmsHead?.A_ToLoc == undefined
    ) {
      iDefaultTaxType =
        LocTo.length > 0 && LocFrom.length > 0
          ? vFromLocation.TaxRegNo == vToLocation.TaxRegNo
            ? sTax[0].Uid
            : sTax[1].Uid
          : sTax[2].Uid;
    }

    dispatch(
      Set_WmsStockTransfer_HeadObject_Set({
        ...vRdxWmsHead,
        A_VocTyp:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocTyp
            : vRdxWmsHead.A_VocTyp,
        A_VocTypName:
          vRdxWmsHead?.A_VocTyp == "" ||
          vRdxWmsHead.A_VocTyp === null ||
          vRdxWmsHead.A_VocTyp === undefined
            ? icurrentDocLoading.VocName
            : vRdxWmsHead.A_VocTypName,

        TaxType:
          vRdxWmsHead.TaxType == "" ||
          vRdxWmsHead.TaxType === null ||
          vRdxWmsHead.TaxType === undefined
            ? iDefaultTaxType
            : vRdxWmsHead.TaxType,
        A_FromLoc:
          vRdxWmsHead.A_FromLoc == "" ||
          vRdxWmsHead.A_FromLoc === null ||
          vRdxWmsHead.A_FromLoc === undefined
            ? vFromLocation?.UId
            : vRdxWmsHead.A_FromLoc,
        A_ToLoc:
          vRdxWmsHead.A_ToLoc == "" ||
          vRdxWmsHead.A_ToLoc === null ||
          vRdxWmsHead.A_ToLoc === undefined
            ? vToLocation.UId
            : vRdxWmsHead.A_ToLoc,
        A_FromTrn:
          vRdxWmsHead.A_FromTrn == "" ||
          vRdxWmsHead.A_FromTrn === null ||
          vRdxWmsHead.A_FromTrn === undefined
            ? vFromLocation.TaxRegNo
            : vRdxWmsHead.A_FromTrn,
        A_ToTrn:
          vRdxWmsHead.A_ToTrn == "" ||
          vRdxWmsHead.A_ToTrn === null ||
          vRdxWmsHead.A_ToTrn === undefined
            ? vToLocation.TaxRegNo
            : vRdxWmsHead.A_ToTrn,
        A_Type:
          vRdxWmsHead.A_Type == "" ||
          vRdxWmsHead.A_Type === null ||
          vRdxWmsHead.A_Type === undefined
            ? sType[0]
            : vRdxWmsHead.A_Type,

        TransferType:
          vRdxWmsHead.TransferType == "" ||
          vRdxWmsHead.TransferType === null ||
          vRdxWmsHead.TransferType === undefined
            ? sTransferType[0].Uid
            : vRdxWmsHead.TransferType,
      })
    );

    fLocationDependency(Locparty, dispatch);
    fLoad_Grid(
      vRdxWmsHead.A_VocNo, //0
      0, //srno
      setDetailGridData,
      setFooterObj,
      vRdxWmsHead?.A_VocTyp == "" ||
        vRdxWmsHead.A_VocTyp === null ||
        vRdxWmsHead.A_VocTyp === undefined
        ? icurrentDocLoading.VocTyp
        : vRdxWmsHead.A_VocTyp,
      sRoundingVal
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, vRdxDBLocation, vRdxGRNtax1, vRdxGRNtax2]);

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  const fkeyup = useCallback((e) => {
    if (e.key === "Enter") {
      let lastChild = document?.getElementById("WmsStockTransferContent");

      let TagArr = !!lastChild
        ? lastChild?.querySelectorAll(".lastkeyDetect")
        : "";
      let ilengthz = !!TagArr ? TagArr?.length : "";

      if (!!ilengthz) {
        if (
          TagArr[ilengthz - 1]?.getElementsByTagName("input")[0]?.name ==
            e.target.name &&
          document?.getElementById("WMSDocStatID")?.innerHTML == "ENTER"
        ) {
          confirmAlert({
            title: "Save",
            message: "Are you want to Save.",
            buttons: [
              {
                className: "alertBtn",
                name: "SaveYes",
                label: "Yes",
                onClick: () => {
                  document.getElementById("IdSave")?.click();
                },
              },
              {
                className: "alertBtn",
                label: "No",
                onClick: () => "",
              },
            ],
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    onload();
  }, [onload]);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);

  useEffect(() => {
    GetHeadLocation(dispatch, setFromLocation, setToLocation);
  }, [dispatch, vRdxWmsHead.A_Type]);

  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "WMINV10";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );

  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);

  const FocusOnLoad = useRef(null);
  useEffect(() => {
    // FocusOnLoad.current?.focus();
  }, []);
  const [GridDataColumnsSearch, setGridDataColumnsSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "VocName", headerName: "Doc.Name", width: 250 },
    { field: "A_VocNo", headerName: "Doc.No", width: 150 },
    {
      field: "A_PostDt",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref.No", width: 90 },
    { field: "LocNameTo", headerName: "Location", width: 130 },
    { field: "A_NetAmt", headerName: "NetAmt", width: 90 },
    { field: "A_DocStat", headerName: "A_DocStat", width: 90, hide: true },
    { field: "A_TransSrNo", headerName: "A_TransSrNo", width: 90, hide: true },
  ]);
  const [GridDataColumnsItemSearch, setGridDataColumnsItemSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
  ]);

  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);
  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "B_Srno", headerName: "Sr.No", width: 50 },
    { field: "B_Itmcd", headerName: "Item Code", width: 100 },
    // { field: "B_Barcode", headerName: "Barcode", width: 100 },
    { field: "ItemName", headerName: "Item Name", width: 250 },
    { field: "B_Qty", headerName: "Qty", width: 50 },
    { field: "B_Unit", headerName: "B_Unit", width: 100, hide: true },
    { field: "UnitName", headerName: "Unit", width: 150 },
    { field: "B_UCost", headerName: "Unit Cost", width: 90 },
    { field: "B_NetAmt", headerName: "Total Value", width: 90 },
    { field: "CostVariance", headerName: "Cost Variance %", width: 90 },
    { field: "B_TaxDept", headerName: "TaxDept", width: 90 },
    { field: "B_TaxPerc", headerName: "TaxPerc", width: 90 },
    { field: "B_TaxAmt", headerName: "TaxAmt", width: 90 },
    { field: "B_CN_Amt", headerName: "B_CN_Amt", width: 90 },
    { field: "B_CN_NeAmt", headerName: "B_CN_NeAmt", width: 100 },
    { field: "B_CN_Tax_Amt", headerName: "B_CN_Tax_Amt", width: 100 },
    { field: "B_Rbt_Amt", headerName: "B_Rbt_Amt", width: 100 },
    { field: "B_Rbt_NeAmt", headerName: "B_Rbt_NeAmt", width: 100 },
    {
      field: "B_Rbt_Tax_Amt",
      headerName: "B_Rbt_Tax_Amt",
      width: 100,
    },

    { field: "B_AvgCost", headerName: "AvgCost", width: 100, hide: true },
    { field: "B_AvgVal", headerName: "AvgVal", width: 100, hide: true },
    {
      field: "B_BaseQty",
      headerName: "B_BaseQty",
      width: 100,
      hide: true,
    },

    {
      field: "B_RSP",
      headerName: "B_RSP",
      width: 100,
      hide: true,
    },

    {
      field: "StkQty",
      headerName: "StkQty",
      width: 100,
      hide: true,
    },
    {
      field: "GP",
      headerName: "GP",
      width: 100,
      hide: true,
    },
  ]);
  useEffect(() => {
    GetGitterColumns(
      setGridDataColumnsWmsSiDetail,
      "STOCK_TRANSFER_DETAIL",
      GridDataColumnsWmsSiDetail
    );
    GetGitterColumns(
      setGridDataColumnsSearch,
      "STOCK_TRANSFER_SEARCH",
      GridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDataColumnsItemSearch,
      "STOCK_TRANSFER_ITEM_SEARCH",
      GridDataColumnsItemSearch
    );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_Loc === null ||
      vRdxWmsHead.A_Loc === undefined ||
      vRdxWmsHead.A_Loc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxWmsHead.A_Loc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxWmsHead.A_Loc,
    vRdxWmsHead.A_DocStat,
  ]);
  return (
    <div className="container-fluid">
      {/* mobile Screen nav  */}
      <GCNAV
        fNew={fNew}
        xDisableNew={sObjRights.RNew == "N"}
        fSave={fSave}
        xDisableSave={sObjRights.RSave == "N"}
        sRightClick={sRigntClick}
        xRightClick={(e) => {
          fLeftClick(e);
          setShowMore(false);
          setRigntClick(false);
          setTimeout(() => {
            document.getElementsByName("A_PostDt")[0]?.focus();
          }, 100);
        }}
        xLeftClick={(e) => {
          fRightClick(e);
          setShowMore(false);
          setRigntClick(true);
          setTimeout(() => {
            document.getElementsByName("B_ItmName")[0]?.focus();
          }, 100);
        }}
        setShowMore={setShowMore}
        sShowMore={sShowMore}
        fDelete={fDelete}
        xDisableDelete={
          vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
            ? false
            : sObjRights.RDelete == "N"
            ? true
            : false
        }
        isBtnDraft={sObjRights.RApprove == "N" && false}
        fDraft={() => {
          fApprove("DRAFT");
        }}
        xDisableDraft={vRdxWmsHead.A_DocStat != "ENTER" ? true : false}
        fApprove={() => {
          fApprove("POST");
        }}
        xDisableApprove={
          vRdxWmsHead.A_DocStat == "ENTER" || vRdxWmsHead.A_DocStat == "DRAFT"
            ? false
            : true
        }
        fView={() => {
          fView();
        }}
        fSummary={() => {
          fSummary();
        }}
        fSearch={() => {
          fSearch();
        }}
      />
      <div style={{ paddingTop: vMediaQuery ? "50px" : "" }}>
        <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
            <div className="Wms-outbound-grv">
              <Grid
                container
                spacing={0}
                className="my-2 Wms-inbound-grn-nav-sm-hide"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={(e) => fNew(0)}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N"}
                    xSize="small"
                    xId={"IdNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N"}
                    xSize="small"
                    xId={"IdSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  {sObjRights.RApprove == "N" && false ? (
                    <CmpButton
                      xbtnName="Draft"
                      xOnClick={() => {
                        fApprove("DRAFT");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat != "ENTER" ? true : false
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  ) : (
                    <CmpButton
                      xbtnName="Approve"
                      xOnClick={() => {
                        fApprove("POST");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat == "ENTER" ||
                        vRdxWmsHead.A_DocStat == "DRAFT"
                          ? false
                          : true
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Search"
                    xOnClick={fSearch}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"IdSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={
                      vRdxWmsHead.A_DocStat == "ENTER" && sBufferObj.B_Srno > 0
                        ? false
                        : sObjRights.RDelete == "N"
                        ? true
                        : false
                    }
                    xSize="small"
                    xId="IdDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="outlined"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    {vRdxWmsHead.A_Type == "DC TO OUTLET" && (
                      <Dropdown.Item
                        id="PrintId"
                        onClick={(e) => {
                          fPrint("WMINV10BRANCH");
                        }}
                      >
                        Stock Transaction - Branch
                      </Dropdown.Item>
                    )}
                    {vRdxWmsHead.A_Type == "DC TO OUTLET" && (
                      <Dropdown.Item
                        onClick={(e) => {
                          fPrint("WMINV10_DC");
                        }}
                      >
                        Stock Transfer- DC
                      </Dropdown.Item>
                    )}
                    {vRdxWmsHead.A_Type == "OUTLET TO DC" && (
                      <Dropdown.Item
                        onClick={(e) => {
                          fPrint("WMINV10");
                        }}
                      >
                        Stock Transfer
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("WMINV10_DOC");
                      }}
                    >
                      Document
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("WMINV10_VAR");
                      }}
                    >
                      Transfer Vs Received
                    </Dropdown.Item>
                    {/* <Dropdown.Item
                      onClick={(e) => {
                        fPrint("");
                      }}
                    >
                      Reference Document
                    </Dropdown.Item> */}
                    {/* <Dropdown.Item
                    onClick={(e) => {
                      fPrint("WMINV10_GP");
                    }}
                  >
                    GP Copy
                  </Dropdown.Item> */}
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Audit"
                    xOnClick={fAudit}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId="IdAudit"
                    xSendIcon={<SendIcon />}
                  />
                </Grid>
                {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                <CmpButton
                  xbtnName="Account Detail"
                  xOnClick={fAccountDetail}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<AccountBalanceOutlinedIcon />}
                />
              </Grid> */}
                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      // { label: "Link Document", onClick: fLinkDocument },
                    ]}
                  />
                </Grid>

                {/* <Grid item xs={1} sm={1} md={1} lg={1}>
                <CmpButton
                  xbtnName="Document"
                  xOnClick={fDocument}
                  xVariant="text"
                  xDisabled={false}
                  xSize="small"
                  xSendIcon={<ArticleRoundedIcon />}
                />
              </Grid> */}
              </Grid>

              <>
                <div id="wms-salese-invoice-id">
                  <div className="wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                    <GCHead
                      //grid saleshistory
                      headGridShow={headGridShow}
                      sHeadGridColumn={sHeadGridColumn}
                      sHeadGridRow={sHeadGridRow}
                      vMediaQuery={vMediaQuery}
                      xDisableBasedOnGridDataLength={sDetailGridData.length > 0}
                      sBufferItmCd={sBufferObj.B_Itmcd !== ""}
                      xErrorMsg={sErrorMsg}
                      sFromLocation={sFromLocation}
                      sToLocation={sToLocation}
                      xKey={fKeyStockTransfer}
                      vRdxWmsHead={vRdxWmsHead}
                      sArr={sArr}
                      fonSelectedGrnType={fGrnType}
                      sDocLoadingGrnType={sDocLoading}
                      sType={sType}
                      sTax={sTax}
                      sTransferType={sTransferType}
                      fGrnDate={fGrnDate}
                      fInvDate={fInvDate}
                      fType={fType}
                      fTax={fTax}
                      fTransferType={fTransferType}
                      fFromLocation={fFromLocation}
                      fToLocation={fToLocation}
                      fCreditLimit={fCreditLimit}
                      fOsAmount={fOsAmount}
                      fAvlAmt={fAvlAmt}
                      xFocusInput={fFocusInput}
                      inputFocus={FocusOnLoad}
                    />
                  </div>
                  <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <div className="wms-incoice-sales-m">
                      <GCContent
                        fReason={(event) => {
                          setBufferObj((obj) => ({
                            ...obj,
                            Reason: event.target.value,
                          }));
                        }}
                        sReason={sReason}
                        sTransItemStockObj={sTransItemStockObj}
                        xTransItemStockShow={
                          vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() ==
                          "Y"
                        }
                        xContent_Focus={fContent_Focus}
                        xContent_Blur={fContent_Blur}
                        xErrorMsgDetail={sErrorMsgDetail}
                        vRdxWmsHead={vRdxWmsHead}
                        xKey={fKeyStockTransferContent}
                        xFocusInput={fFocusInput}
                        xBufferObj={sBufferObj}
                        sUnit={sUnit}
                        vRdxGRNtax1={vRdxGRNtax1}
                        vRdxGRNtax2={vRdxGRNtax2}
                        fUnit={fUnit}
                        fQty_Save_onKeyUp={fQty_Save_onKeyUp}
                        fOpenContentItemSearchModalKey={fItemSearchKey}
                        fQty={fQty}
                        //GC toggle
                        fItemName={fItemName} //onchange main input
                        xMediaQuery={vMediaQuery} //mobile screen
                        xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                        xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                        xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                        xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                        xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                        xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                        xData={ItemSearchData} // GCToggleSearch-select-tag arr
                        xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                        xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                        xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch-
                      />
                      {vMediaQuery && (
                        <DetailTblCard
                          data={sDetailGridData}
                          onClick={fDetail_Grid_onRowClick}
                          fDelete={fDelete}
                          xDisableDelete={
                            vRdxWmsHead.A_DocStat == "ENTER"
                              ? false
                              : sObjRights.RDelete == "N"
                              ? true
                              : false
                          }
                        />
                      )}
                    </div>
                    <div className="wms-sales-content-grid xs-screen-hide">
                      <div style={{ height: "30vh", width: "100%" }}>
                        <DataGrid
                          rowHeight={30}
                          headerHeight={40}
                          getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0
                              ? "mui-even-row"
                              : "mui-odd-row"
                          }
                          sx={{
                            border: 1,
                            borderColor: "primary.light",
                          }}
                          rows={sDetailGridData}
                          columns={GridDataColumnsWmsSiDetail}
                          onRowClick={fDetail_Grid_onRowClick}
                          hideFooter={sDetailGridData.length < 100}
                          // components={{
                          //   Toolbar: GridToolbar,
                          // }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                    <WmsFooter
                      xErrorMsg={sErrorMsg}
                      xFooterObj={sFooterObj}
                      xKey={fKeyStockTransfer}
                      vRdxWmsHead={vRdxWmsHead}
                      sArr={sArr}
                      fHeadNarration={fHeadNarration}
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Variance"} onClose={fCloseViewModal} />

          <div className="py-3">
            <div style={{ height: "65vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sDetailGridData}
                columns={GridDataColumnsWmsSiDetail}
                onRowClick={fDetail_Grid_onRowClick}
                hideFooter={sDetailGridData.length < 100}
                // components={{
                //   Toolbar: GridToolbar,
                // }}
              />
            </div>
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary "} onClose={fCloseSummaryModal} />

          <div className="py-3">
            <WmsFooter
              xErrorMsg={sErrorMsg}
              xFooterObj={sFooterObj}
              xKey={fKeyStockTransfer}
              vRdxWmsHead={vRdxWmsHead}
              sArr={sArr}
              fHeadNarration={fHeadNarration}
            />
          </div>
        </Box>
      </Modal>
      {/* Reverse Modal */}
      <GCReverse
        open={sReverseTransactionModal}
        fCloseReverseTransactionModal={(e) => {
          fCloseReverseTransactionModal(setReverseTransactionModal);
        }}
        sRevNarr={sRevNarr}
        setRevNarr={setRevNarr}
        fReverse={(e) => {
          fReverse(fSave, setRevNarr, setReverseTransactionModal);
        }}
      />
      {/* Search  */}
      <GCStockTransfer
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sLocationArr}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangeLocModal={fonChangeLocModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={GridDataColumnsSearch}
        xOnCellKeyDownSearch={fTrans_Search_Grid_KeyDown}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"Stock Transfer - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
        xRefNoVal={sSearchModalObj.RefNo}
      />
      {/* Audit  */}
      {/* <GCAudit
        xOpen={sAuditModal}
        xTitle={"AUDIT"}
        fCloseAuditModal={fCloseAuditModal}
        sAuditSelectArr={sAuditSelectArr}
        GridDataAuditColumns={GridDataAuditColumns}
        GridDataAuditRows={sGridDataAuditRows}
        xAuditId={xAuditId}
        fonChangeAuditSelect={fonChangeAuditSelect}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
      /> */}
      <GCAuditTblCard
        xOpen={sAuditModal}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
        fCloseAuditModal={setAuditModal}
        trnTyp={sTrnTyp}
        vocTyp={vRdxWmsHead.A_VocTyp}
        vocNo={vRdxWmsHead.A_VocNo}
      />
      <Modal
        open={sDocumentModal}
        onClose={fCloseDocumentModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-popup">on progerss document...</Box>
      </Modal>
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
    </div>
  );
}
